import React, { useState } from "react";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import Icon from "@visa/vds/icon";
import MCSPagedTable from "../../../components/MCSPagedTable";
import { cloneDeep } from "lodash";
import { DateHelper } from "../../../_helpers/DateHelper";
import "../Components/DafUploadFileTable.css";
import ButtonIcon from "@visa/vds/button-icon";

const DafUploadFileTable = (props) => {
  const alertObj = props.alertObj;
  const tableData = props.tableData;
  const fetchData = props.fetchData;
  const handleDownloadErrorLog = props.handleDownloadErrorLog;
  const [selectedPage, setSelectedPage] = useState(1);
  const [sortBy, setSortBy] = useState(props.defaultSortBy);
  const [desc, setDesc] = useState(props.defaultDesc);
  const [filter, setFilter] = useState(props.defaultFilter);

  let colHeaders = [
    {
      displayName: "File Upload ID",
      name: "Id",
      orderable: false,
    },
    {
      displayName: "File Name",
      name: "FileName",
      orderable: true,
    },
    {
      displayName: "Tab 1 Upload Result (Processed/Total)",
      name: "TabOneProcessResults",
      orderable: false,
    },
    {
      displayName: "Tab 2 Upload Result (Processed/Total)",
      name: "TabTwoProcessResults",
      orderable: false,
    },
    {
      displayName: "Tab 3 Upload Result (Processed/Total)",
      name: "TabThreeProcessResults",
      orderable: false,
    },
    {
      displayName: "Uploaded By",
      name: "CreatedBy",
      orderable: true,
    },
    {
      displayName: "Uploaded On",
      name: "CreatedOn",
      orderable: true,
    },
    {
      displayName: "Process Result",
      name: "download",
      orderable: false,
    },
    {
      displayName: "VSS Error Log",
      name: "errorLog",
      orderable: false,
    },
    { displayName: "File Details", name: "action", orderable: false },
  ];

  function processParams(filter) {
    if (filter === null) return null;
    let process = cloneDeep(filter);
    return process;
  }

  function fetch(page, sortBy, desc, filter) {
    fetchData(page, sortBy, desc, filter, alertObj);
  }

  function handleSearchChange(searchValue) {
    setSelectedPage(1);
    let searchFilter = processParams(filter);
    searchFilter.search = searchValue;
    fetch(1, sortBy, desc, searchFilter);
  }

  const handleSortChange = async (sortBy = null, desc = false) => {
    fetch(selectedPage, sortBy, desc, filter);
  };

  const handlePageChange = (newPage) => {
    setSelectedPage(newPage);
    fetch(newPage, sortBy, desc, filter);
  };

  return (
    <>
      {tableData && (
        <MCSPagedTable
          size={"compact"}
          colHeaders={colHeaders}
          useSearchBar={true}
          searchHelpText={"Search File Name"}
          searchVal={filter.search}
          setSearchVal={(value) => {
            setFilter({ ...filter, search: value });
          }}
          handleSearchChange={handleSearchChange}
          usePagination={true}
          selectedPage={selectedPage}
          setSelectedPage={handlePageChange}
          totalPages={props.totalPage}
          pageSize={props.pageSize}
          totalCount={props.totalCount}
          ordered={sortBy}
          setOrdered={setSortBy}
          sortData={handleSortChange}
          isDsc={desc}
          setDsc={setDesc}
          tableData={
            tableData &&
            tableData.map((row, key) => (
              <Tr key={key}>
                <Td>{row.id}</Td>
                <Td>{row.fileName}</Td>
                <Td>{row.tabOneProcessResults}</Td>
                <Td>{row.tabTwoProcessResults}</Td>
                <Td>{row.tabThreeProcessResults}</Td>
                <Td>{row.createdBy}</Td>
                <Td>{DateHelper.ToLocaleDateString(row.createdOn)}</Td>
                <Td textAlign="center">
                  <ButtonIcon
                    iconType="light"
                    className="vss-clickable-icon"
                    onClick={() => props.handleDownloadProcessFile(row)}
                  >
                    <Icon name="file-download" resolution="low" />
                  </ButtonIcon>
                </Td>
                <Td textAlign="center">
                  <ButtonIcon
                    className={
                      row.hasDafUploadLog
                        ? "vss-clickable-icon vss-daf-error-log-icon"
                        : "vss-daf-error-log-icon"
                    }
                    iconType="light"
                    disabled={!row.hasDafUploadLog}
                    onClick={() => handleDownloadErrorLog(row, alertObj)}
                  >
                    <Icon name="file-download" resolution="low" />
                  </ButtonIcon>
                </Td>
                <Td>
                  <ButtonIcon
                    iconType="light"
                    className="vss-clickable-icon"
                    onClick={() => props.handleClickAction(row)}
                  >
                    <Icon name="options-vertical" resolution="low" />
                  </ButtonIcon>
                </Td>
              </Tr>
            ))
          }
        />
      )}
    </>
  );
};
export default DafUploadFileTable;
